/**
 * @generated SignedSource<<4f24fd871be04fa096942066b2ed289a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountCodeForm_DiscountCodeFragment$data = {
  readonly code: string;
  readonly id: string;
  readonly " $fragmentType": "DiscountCodeForm_DiscountCodeFragment";
};
export type DiscountCodeForm_DiscountCodeFragment$key = {
  readonly " $data"?: DiscountCodeForm_DiscountCodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiscountCodeForm_DiscountCodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiscountCodeForm_DiscountCodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "type": "DiscountCode",
  "abstractKey": null
};

(node as any).hash = "ef62bc2190c531a00bfeb950ea8a387f";

export default node;
